export default __webpack_public_path__ + "static/media/Truck_Flatbad_Icon.15bbb882.svg";